import React from 'react';
import { ChevronDown } from './Icons';
import { cn } from '../../utils/cn';

export function Select({ label, value, onChange, options, placeholder, required, className }) {
  return (
    <div className={cn("relative w-full space-y-1", className)}>
      <label className="text-[10px] font-bold text-gray-500 uppercase tracking-tighter ml-1">
        {label}
      </label>
      <div className="relative">
        <select 
          value={value || ''} 
          onChange={(e) => onChange(e.target.value)}
          required={required}
          className="w-full bg-dark-card border border-white/10 rounded-lg px-3 py-2 text-sm appearance-none text-white focus:outline-none focus:border-brand-blue transition-all"
        >
          <option value="" disabled>{placeholder || `Select`}</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
          <ChevronDown size={14} />
        </div>
      </div>
    </div>
  );
}